import { Navigate, useLocation } from "react-router-dom";
import { UC_ADMIN_SESSION_KEY } from "../constants";

export function setAdminSession() {
    sessionStorage.setItem(UC_ADMIN_SESSION_KEY, "1");
}

export function clearAdminSession() {
    sessionStorage.removeItem(UC_ADMIN_SESSION_KEY);
}

export function isAdminSession() {
    return sessionStorage.getItem(UC_ADMIN_SESSION_KEY) === "1";
}

export default function ProtectedRoute({ children }) {
    const location = useLocation();
    if (!isAdminSession()) {
        return <Navigate to="/login" replace state={{ from: location.pathname }} />;
    }
    return children;
}
